import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { canvasQaRunCacheKeys } from "./constants";
import type { DeleteCanvasQaRunProps, DeleteCanvasQaRunResult } from "./types";

/** DELETE handler for the "/:app_group_id/canvas_qa_runs/:canvas_id" endpoint. */
export const deleteCanvasQaRun = reactQueryMutationAdapter(
  canvasQaRunCacheKeys,
  (props: DeleteCanvasQaRunProps): Promise<DeleteCanvasQaRunResult> => {
    return fetch(`/${props.appGroupId}/canvas_qa_runs/${props.canvasId}`, "DELETE", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
